module.exports = __webpack_public_path__ + "static/media/16UNODC30.d2f04f33.jpg";